import { render, staticRenderFns } from "./UnknownButton.vue?vue&type=template&id=98b29a2a"
import script from "./UnknownButton.vue?vue&type=script&lang=js"
export * from "./UnknownButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports